import { render, staticRenderFns } from "./barreraAutomatica.vue?vue&type=template&id=b7284c20&scoped=true&"
import script from "./barreraAutomatica.vue?vue&type=script&lang=js&"
export * from "./barreraAutomatica.vue?vue&type=script&lang=js&"
import style0 from "./barreraAutomatica.vue?vue&type=style&index=0&id=b7284c20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7284c20",
  null
  
)

export default component.exports